let controller = new AbortController();

export const getAbortSignal = () => controller.signal;

export const abortAllRequests = () => {
  controller.abort();
  controller = new AbortController();
};
